/**
 * Twitch-link onboarding mockup. Mirrors the in-app account-link
 * card that members hit when wiring up their Twitch handle so live
 * detection auto-flips their tile in the squadron Live tab.
 *
 * Two states shown side-by-side: unlinked (CTA prompt) and linked
 * (success state with disconnect option) — visitors see both the
 * before and after in one mockup.
 */
export function TwitchLinkMockup() {
  return (
    <div className="space-y-3 p-5">
      <div className="rounded-xl border border-border bg-bg/40 p-4">
        <div className="flex items-start gap-3">
          <TwitchLogo />
          <div className="min-w-0 flex-1">
            <p className="font-display text-sm font-bold text-fg">
              Twitch
            </p>
            <p className="mt-1 text-xs text-fg-muted">
              Link your Twitch handle and we'll detect when you go
              live, so your squadron sees you in the Live tab.
            </p>
            <button
              type="button"
              className="font-display mt-3 inline-flex items-center gap-1.5 rounded-md bg-[#9146FF] px-3 py-1.5 text-xs font-bold tracking-wider text-white"
              tabIndex={-1}
            >
              Connect Twitch
            </button>
          </div>
        </div>
      </div>

      <div className="rounded-xl border border-success/40 bg-success/[0.04] p-4">
        <div className="flex items-start gap-3">
          <TwitchLogo />
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <p className="font-display text-sm font-bold text-fg">
                Twitch
              </p>
              <span className="font-display rounded-sm bg-success/15 px-1.5 py-[1px] text-[9px] font-extrabold tracking-[0.2em] text-success uppercase">
                Linked
              </span>
            </div>
            <p className="mt-1 text-xs text-fg-muted">
              Connected as <span className="font-display font-bold text-fg">@orion_blk</span> ·
              auto-detects live status every 60s
            </p>
            <p className="font-display mt-2 inline-flex items-center gap-1.5 text-[10px] font-extrabold tracking-[0.22em] text-success uppercase">
              <span className="size-1.5 rounded-full bg-success" />
              Currently live · 247 viewers
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

function TwitchLogo() {
  return (
    <div
      className="flex size-9 shrink-0 items-center justify-center rounded-md"
      style={{ backgroundColor: '#9146FF' }}
      aria-hidden
    >
      <svg viewBox="0 0 24 24" className="size-5 fill-white">
        <path d="M2 4l1.5-3.5h17V14l-5 5h-3.5l-2 2H6.5v-2H2V4zm2 13.5h3.5v2.5l2-2.5H14l3-3V2.5H4v15zm9-9V5h2v3.5h-2zm-5 0V5h2v3.5H8z" />
      </svg>
    </div>
  )
}
